import { WBFlex, WBTypography } from "@apptractive/design-system-web";
import { stripeGetAmountCurrency } from "@apptractive/stm-shared";
import { Box, Divider, Skeleton, Stack } from "@mui/material";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { StripeLineItem, StripeSession } from "../../API";

interface StripeCheckoutSubscriptionProps {
  checkout: StripeSession;
  loading: boolean;
}

export const StripeCheckoutSubscription = ({
  checkout,
  loading,
}: StripeCheckoutSubscriptionProps) => {
  const { t } = useTranslation();
  const lineItems: any = useMemo(
    () => checkout?.line_items?.data || [],
    [checkout]
  );

  return (
    <>
      <Divider sx={{ mt: 2 }} />
      {lineItems?.map((lineItem: StripeLineItem) => (
        <WBFlex key={lineItem.id} justifyContent="space-between" my={3}>
          <WBTypography fontWeight={600}>{lineItem?.description}</WBTypography>
          <WBTypography fontWeight={600}>
            {stripeGetAmountCurrency(lineItem.currency, lineItem.amount_total)}
          </WBTypography>
        </WBFlex>
      ))}

      {loading && <Skeleton variant="text" width="100%" sx={{ my: 3 }} />}

      <Divider sx={{ mb: 1 }} />

      <WBFlex>
        <Box flex={1} />
        <Box flex={1}>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
          >
            <WBTypography>
              {t("subtotalTitle", { ns: "purchase" })}
            </WBTypography>
            <WBTypography fontWeight="bold">
              {loading ? (
                <Skeleton variant="text" width={50} />
              ) : (
                stripeGetAmountCurrency(
                  checkout.currency,
                  checkout.amount_subtotal
                )
              )}
            </WBTypography>
          </Stack>
          <Divider sx={{ my: 1 }} />
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
          >
            <WBTypography fontWeight="bold">
              {t("totalTitle", { ns: "purchase" })}
            </WBTypography>
            <WBTypography fontWeight="bold">
              {loading ? (
                <Skeleton variant="text" width={50} />
              ) : (
                stripeGetAmountCurrency(
                  checkout.currency,
                  checkout.amount_total
                )
              )}
            </WBTypography>
          </Stack>
          <Divider sx={{ my: 1 }} />
        </Box>
      </WBFlex>
    </>
  );
};
